<nav style="background-color: rgb(0, 128, 255);">
	<div class="container">
		<div class="row">
			<div class="text-center col-sm-12 col-md-2 col-lg-2 col-xl-2">
				<img (click)="clicksound()" (mouseenter)="hoversound()" routerLink="/connecter" src="../assets/img/homeicon.png" width="30" height="30" />
			</div>
			<div class="text-center text-left col-sm-12 col-md-5 col-lg-5 col-xl-5">

			</div>
			<div class=" text-center col-sm-12 col-md-3 col-lg-3 col-xl-3">
			</div>
			<div class="text-center col-sm-12 col-md-2 col-lg-2 col-xl-2">
				<h4>
					<a href="mailto: moahmeddhia.jebali@isticbc.org"  (click)="clicksound()" (mouseenter)="hoversound()" class="btn btn-outline-warning btn-sm">Contacter</a> &nbsp;
      
					<input (mouseenter)="hoversound()" (click)="clicksound()" (click)="aproposderun()" type="button" name="aproposde" id="aproposde" class="btn btn-outline-warning btn-sm" value="À propos de"> &nbsp;
					</h4>
				</div>
			</div>
		</div>
	</nav>
  
  <br>
  
  
  
  
  
  
  
  <br><br>
  <img src="../assets/img/icon.png" style="  display: block; margin-left: auto; margin-right: auto;" width="100" height="80">
  <br>  
  <form>
  <div class="container">
  
    <div class="row">
  
      <div class="col-xl-12" style="text-align:center">
        <h1 style="font-size:50px;">Gestion des Employés</h1>
      </div>
  
      <br> <br> <br> <br>  <br> <br> <br> <br> 
  
      
      <div class="col-xl-6" style="text-align:center">
          <h3>Entreprise ID(EID)   <input type="text" id="eid" name="eid" value=""></h3>
        
        </div>
  
        
      <div class="col-xl-6" style="text-align:center">
          <h3>Mot de Passe <input type="password" id="motdepasse" name="motdepasse" value=""></h3>
          
        </div>
  
        <div class="col-xl-12" style="text-align:center">
          <br> <br> 
          <input type="button" (click)="clicksound()" (click)="backend_connecter()" (mouseenter)="hoversound()" id="connecterbtn" name="connecterbtn" value="Connecter" class="btn btn-primary btn-lg">
          
        </div>
  
    </div>
  
  </div>
  </form>
  
  
  